import React, { memo } from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { getChipStyles } from './ToleranceChip.styles';

const ToleranceChip = ({ config }) => {
  if (!config) {
    return null;
  }

  return (
    <Typography component="span" sx={getChipStyles(config.variant)} variant="medium12">
      {config.label}
    </Typography>
  );
};

ToleranceChip.propTypes = {
  config: PropTypes.shape({
    label: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(['error', 'warning', 'neutral']).isRequired,
  }),
};

export default memo(ToleranceChip);
